// Ripped-off from https://github.com/Hanse/react-calendar
import { last, range, takeWhile } from 'lodash'
import moment from 'moment'

export interface DateObject {
  day: moment.Moment
  classNames: string
}

function getClassNames(day: moment.Moment): string[] {
  const classes = []
  const today = moment() // This is the current date from the current system

  if (day.isSame(today, 'day')) classes.push('today')

  if (day.day() === 0) classes.push('sunday weekend')

  if (day.day() === 6) classes.push('saturday weekend')

  return classes
}
/**
 * Generate an array of calendar days for a given date
 * This will include all the days of the current month
 * plus the previous/next month if any.
 *
 * This array will be used by the views to render the calendar
 */

export default function createDateObjects(date: moment.Moment): DateObject[] {
  const startOfMonth = date.startOf('month')
  let diff = startOfMonth.weekday()

  if (diff < 0) diff += 7

  const prevMonthDays = range(0, diff).map((n) => {
    const day = startOfMonth.clone().subtract(diff - n, 'days')

    return {
      day,
      classNames: getClassNames(day).concat(['prevMonth']).join(' ')
    }
  })

  const currentMonthDays = range(1, date.daysInMonth() + 1).map((index) => {
    const day = moment([date.year(), date.month(), index])

    return {
      day,
      classNames: getClassNames(day).join(' ')
    }
  })

  const daysAdded = prevMonthDays.length + currentMonthDays.length - 1

  const nextMonthDays = takeWhile(range(1, 7), (n) => (daysAdded + n) % 7 !== 0).map((n) => {
    const lastday = last(currentMonthDays)

    if (!lastday) throw Error('Unable to compute last day')

    const day = lastday.day.clone().add(n, 'days')

    return {
      day,
      classNames: getClassNames(day).concat(['nextMonth']).join(' ')
    }
  })

  return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays]
}
